var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPresent)?_c('b-row',[_c('b-col',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.info.helpPrompt)}})])],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }